import * as PropTypes from 'prop-types';
import { useLocales } from '../../../../locales';
import { useEffect, useState } from 'react';
import { getImageUrl } from '../../../../firebase/utils';
import { useTranslate } from '@tolgee/react';
import userImage from '../../../../assets/images/placeholders/user/user.png';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import MessageContent from './messageContent';
import { addUrl } from '../../../../redux/slices/communication';
import { useDispatch, useSelector } from 'react-redux';
import { resolveAttachmentKind } from '../../utils/attachmentUtils';
export default function Message({ data, left = true, rules }) {
  const { currentLang } = useLocales();
  const { t } = useTranslate();
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [attachment, setAttachment] = useState(null);
  const handleDivClick = (url) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = url;
    downloadLink.click();
  };
  const {
    data: { activeConversation }
  } = useSelector((state) => state.communication);
  const dataIsNotEmpty = (data) => {
    return (
      (data?.message_content_html !== '' &&
        data?.message_content_html !== '<p></p>' &&
        data?.message_content_html !== null) ||
      (data?.message_content !== '' && data?.message_content !== null)
    );
  };

  /*
   * Returns true if an attachment has not been expired
   * */
  const attachmentIsAvailable = (attachment) => {
    if (!attachment?.expires) return true;
    return attachment?.expires * 1000 > Date.now();
  };
  const [imageErrorMap, setImageErrorMap] = useState({});
  const [videoErrorMap, setVideoErrorMap] = useState({});

  const handleAttachmentClick = (clickedAttachment, event) => {
    // Pause inline media so clicking to open the modal doesn't toggle playback
    event?.preventDefault();
    event?.stopPropagation();

    const target = event?.currentTarget;

    if (target?.pause) {
      target.pause();
    }

    setAttachment(clickedAttachment);
    handleShow();
  };

  return (
    <div
      className={`d-flex ${
        left ? 'flex-column align-items-start' : 'justify-content-end mb-10'
      }`}
    >
      <div
        className={`d-flex ${
          left ? 'flex-column align-items-start' : 'flex-column align-items-end'
        }`}
      >
        {(dataIsNotEmpty(data) ||
          data?.attachment?.length > 0 ||
          data.rating) && (
          <div
            className={`d-flex align-items-center ${
              data.rating ? 'mb-4' : 'mb-2'
            }`}
          >
            {!left && (
              <div className="me-3">
                <span className="text-muted fs-7 mb-1">
                  {data.platform_created
                    ? new Date(data.platform_created).toLocaleString(
                        currentLang.systemValue,
                        {
                          year: '2-digit',
                          month: 'numeric',
                          day: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric'
                        }
                      )
                    : null}
                </span>
                <a className="fs-5 fw-bold text-gray-900 text-hover-primary ms-1">
                  {data?.social_media_platform_user?.name || t('You')}
                </a>
              </div>
            )}
            <UserAvatar data={data} />
            {left && (
              <div className="ms-3">
                <a className="fs-5 fw-bold text-gray-900 text-hover-primary me-1">
                  {data?.social_media_platform_user?.name || t('unknown')}
                </a>
                <span className="text-muted fs-7 mb-1">
                  {data.platform_created
                    ? new Date(data.platform_created).toLocaleString(
                        currentLang.systemValue,
                        {
                          year: '2-digit',
                          month: 'numeric',
                          day: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric'
                        }
                      )
                    : null}
                </span>
              </div>
            )}
          </div>
        )}

        {(dataIsNotEmpty(data) || activeConversation.type === 'review') && (
          <MessageContent data={data} left={left} rules={rules} />
        )}

        {data?.attachment?.map((attachment, i) => {
          if (!attachment.url) return null;
          const attachmentKind = resolveAttachmentKind(attachment);
          const failedImage = imageErrorMap[attachment.url];
          return (
            <div
              key={i}
              className={`px-5 pt-5 rounded ${
                data?.is_internal_note
                  ? 'bg-light-warning'
                  : data.is_sent_by_me
                  ? 'bg-light-primary'
                  : 'bg-light-info'
              } pb-5`}
              style={{
                marginLeft: left ? '45px' : undefined, // Added 'px' for margin value
                position: 'relative',
                maxWidth:
                  attachmentKind === 'download'
                    ? '100%'
                    : !attachmentIsAvailable(attachment)
                    ? '100%'
                    : '33%',
                // maxHeight: "300px",
                height: '300px !important',
                display: 'inline-block' // Ensure the div wraps the image and matches its width
              }}
            >
              {!attachmentIsAvailable(attachment) ? (
                <div className={'fw-bolder small'}>
                  {t('AttachmentExpired')}
                </div>
              ) : (
                <>
                  {attachmentKind === 'image' && !failedImage && (
                    <div>
                      <img
                        src={attachment.url}
                        alt={`Attachment ${i}`}
                        className="cursor-pointer"
                        style={{ maxWidth: '100%' }}
                        onClick={(event) => {
                          handleAttachmentClick(attachment, event);
                        }}
                        onError={() =>
                          attachment.type === null
                            ? setImageErrorMap((prev) => ({
                                ...prev,
                                [attachment.url]: true
                              }))
                            : setImageErrorMap((prev) => ({
                                ...prev,
                                [attachment.url]: true
                              }))
                        }
                      />
                    </div>
                  )}
                  {(attachmentKind === 'video' ||
                    (attachment.type === null && failedImage)) && (
                    <video
                      src={attachment.url}
                      className="img-fluid cursor-pointer h-100"
                      preload="metadata"
                      title={`Attachment ${i}`}
                      onClick={(event) => {
                        handleAttachmentClick(attachment, event);
                      }}
                      controls
                      onError={() =>
                        setVideoErrorMap((prev) => ({
                          ...prev,
                          [attachment.url]: true
                        }))
                      }
                    >
                      Your browser does not support the video tag.
                    </video>
                  )}
                  {attachmentKind === 'download' && (
                    <div
                      onClick={() => handleDivClick(attachment.url)}
                      style={{ cursor: 'pointer' }}
                      className="d-flex align-items-center"
                    >
                      <p
                        className="text-nowrap mb-0 fs-5"
                        style={{ marginRight: 10 }}
                      >
                        <b>{t('Attachment')}</b>
                      </p>
                      <div className="m-2">
                        <FontAwesomeIcon
                          style={{ color: '#7339ea' }}
                          icon={duotone('cloud-arrow-down')}
                          size="2x"
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
      <Modal show={showModal} onHide={handleClose} centered closeButton>
        <Modal.Header closeButton>
          {/* Close button in the top right corner */}
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center align-items-center">
            {attachment &&
              resolveAttachmentKind(attachment) === 'image' &&
              !imageErrorMap[attachment.url] && (
                <img
                  src={attachment?.url}
                  alt="Attachment"
                  className="img-fluid"
                  onError={() =>
                    attachment?.type === null &&
                    setImageErrorMap((prev) => ({
                      ...prev,
                      [attachment.url]: true
                    }))
                  }
                />
              )}
            {attachment &&
              (resolveAttachmentKind(attachment) === 'video' ||
                (attachment.type === null &&
                  imageErrorMap[attachment.url])) && (
                <video
                  src={attachment.url}
                  alt={`Attachment `}
                  className="img-fluid cursor-pointer"
                  controls
                />
              )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

Message.propTypes = {
  data: PropTypes.any,
  left: PropTypes.bool,
  rules: PropTypes.object
};

export const UserAvatar = ({ data }) => {
  const dispatch = useDispatch();
  const {
    data: { urls }
  } = useSelector((state) => state.communication);
  useEffect(() => {
    if (data?.social_media_platform_user?.image_file)
      if (urls?.[data?.social_media_platform_user?.image_file])
        setImageUrl(urls[data?.social_media_platform_user?.image_file]);
      else
        getImageUrl(data?.social_media_platform_user?.image_file)
          .then((url) => {
            dispatch(addUrl(data?.social_media_platform_user?.image_file, url));
            setImageUrl(url);
          })
          .catch((err) => console.log(err));
    else {
      if (data.is_internal_note) setInitialsAvatar(true);
    }
  }, [data]);
  const [imageUrl, setImageUrl] = useState(userImage);
  const [initialsAvatar, setInitialsAvatar] = useState(false);
  const [imageError, setImageError] = useState(false);
  return (
    <div
      className="symbol symbol-35px symbol-circle h-35px"
      style={{ height: 35 }}
    >
      {initialsAvatar ? (
        <div className="symbol-label fs-5 fw-semibold text-success">
          {data?.social_media_platform_user?.initials}
        </div>
      ) : (
        <>
          {imageUrl && !imageError && (
            <img src={imageUrl} onError={() => setImageError(true)} />
          )}
          {(!imageUrl || imageError) && (
            <img src={userImage} alt="user" className="symbol-label" />
          )}
        </>
      )}
    </div>
  );
};

UserAvatar.propTypes = {
  data: PropTypes.any
};
